import { UnitConversionFactor } from "./UnitConversionFactor";
import { UnitConversionFactorGroup } from "./UnitConversionFactorGroup";
import { WeightUnits } from "./WeightUnits";

export class WeightConversionFactors {
    public static readonly KG_TO_LB =
        new UnitConversionFactor(2.204623, WeightUnits.KILOGRAM, WeightUnits.POUND);
    public static readonly LB_TO_KG =
        new UnitConversionFactor(0.4535924, WeightUnits.POUND, WeightUnits.KILOGRAM);

    private static readonly group = new UnitConversionFactorGroup(this.KG_TO_LB, this.LB_TO_KG);

    public static get(): UnitConversionFactorGroup {
        return this.group;
    }
}
